export const WIZARD_STEP_HEIGHT = 350;
export const WIZARD_STEP_CLASSNAME = 'p-x-14';